import React from 'react'
import Iframe from 'react-iframe'

const IrdPanSearch = () => {
  return (
    <div className="">
    <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
     IRD Pan Search
    </h1>
    <div className="">
      <img
        src="../../images/title-border.png"
        alt=""
        className="mx-auto mt-4"
      />
    </div>
    {/* iframe */}
    <div className="">
      {/* <iframe src="https://ocr.gov.np/" width={540} height={450}></iframe> */}
      {/* <div dangerouslySetInnerHTML={ iframe} /> */}
      <Iframe url="https://ird.gov.np/pan-search"
      
      height="500px"
      id=""
      className="w-full"
      display="block"
      position="relative"/>

    </div>
  </div>
  )
}

export default IrdPanSearch